// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lr-btn-card {
  border: solid 1px #403C3C;
  background-color: #fff;
  width: 100%;
  margin-bottom: 10px;
  text-align: left;
  padding: 17px 16px;
  border-radius: 8px;
}
.lr-btn-card:hover {
  border: solid 2px #6e6e6e;
  padding: 16px 15px;
}
.lr-btn-card:active {
  border: solid 2px #003a65;
  padding: 16px 15px;
}
.lr-btn-card:focus {
  border: solid 2px #0a70bc;
  padding: 16px 15px;
}
.lr-btn-card:selected {
  border: solid 2px #0a70bc;
  background-color: #edf8fc;
  padding: 16px 15px;
}
.lr-btn-card:disabled {
  border: solid 1px #cbcbcb;
  background-color: #f3f3f3;
}
.lr-btn-card:disabled .lr-btn-heading,
.lr-btn-card:disabled .lr-btn-body {
  color: #cbcbcb;
}

.lr-btn-card:disabled:hover {
  padding: 17px 16px;
}

.lr-btn-answer {
  border: 1px solid #403C3C;
  background-color: #F3F2F2;
  font-weight: 600;
}

.lr-button-flex-container {
  display:flex;
  flex-direction: row;
}

.lr-button-flex-item-grow {
  flex-grow:1;
}
.olr-policy-header-margin {
  margin-bottom: 2px;;
}
.olr-button-body {
  text-align: left;
  padding: 16px;
  height: auto;
  margin-bottom: 16px;
}
.vertical-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

b {
  color:#D62311;
}

.helpful-tips-format {
  text-align: right;
  margin-bottom: 1%;
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/entry-point/button-policy-option/button-policy-option.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".lr-btn-card {\n  border: solid 1px #403C3C;\n  background-color: #fff;\n  width: 100%;\n  margin-bottom: 10px;\n  text-align: left;\n  padding: 17px 16px;\n  border-radius: 8px;\n}\n.lr-btn-card:hover {\n  border: solid 2px #6e6e6e;\n  padding: 16px 15px;\n}\n.lr-btn-card:active {\n  border: solid 2px #003a65;\n  padding: 16px 15px;\n}\n.lr-btn-card:focus {\n  border: solid 2px #0a70bc;\n  padding: 16px 15px;\n}\n.lr-btn-card:selected {\n  border: solid 2px #0a70bc;\n  background-color: #edf8fc;\n  padding: 16px 15px;\n}\n.lr-btn-card:disabled {\n  border: solid 1px #cbcbcb;\n  background-color: #f3f3f3;\n}\n.lr-btn-card:disabled .lr-btn-heading,\n.lr-btn-card:disabled .lr-btn-body {\n  color: #cbcbcb;\n}\n\n.lr-btn-card:disabled:hover {\n  padding: 17px 16px;\n}\n\n.lr-btn-answer {\n  border: 1px solid #403C3C;\n  background-color: #F3F2F2;\n  font-weight: 600;\n}\n\n.lr-button-flex-container {\n  display:flex;\n  flex-direction: row;\n}\n\n.lr-button-flex-item-grow {\n  flex-grow:1;\n}\n.olr-policy-header-margin {\n  margin-bottom: 2px;;\n}\n.olr-button-body {\n  text-align: left;\n  padding: 16px;\n  height: auto;\n  margin-bottom: 16px;\n}\n.vertical-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nb {\n  color:#D62311;\n}\n\n.helpful-tips-format {\n  text-align: right;\n  margin-bottom: 1%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
